/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `new` - New
 * * `detected` - Detected
 * * `investigating` - Investigating
 * * `reported` - Reported
 * * `takendown` - Taken Down
 * @export
 */
export const Status7f3Enum = {
    New: 'new',
    Detected: 'detected',
    Investigating: 'investigating',
    Reported: 'reported',
    Takendown: 'takendown'
} as const;
export type Status7f3Enum = typeof Status7f3Enum[keyof typeof Status7f3Enum];


export function instanceOfStatus7f3Enum(value: any): boolean {
    for (const key in Status7f3Enum) {
        if (Object.prototype.hasOwnProperty.call(Status7f3Enum, key)) {
            if (Status7f3Enum[key as keyof typeof Status7f3Enum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function Status7f3EnumFromJSON(json: any): Status7f3Enum {
    return Status7f3EnumFromJSONTyped(json, false);
}

export function Status7f3EnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status7f3Enum {
    return json as Status7f3Enum;
}

export function Status7f3EnumToJSON(value?: Status7f3Enum | null): any {
    return value as any;
}

export function Status7f3EnumToJSONTyped(value: any, ignoreDiscriminator: boolean): Status7f3Enum {
    return value as Status7f3Enum;
}

